import React, { useEffect } from 'react'
import Item from './Item.js';

function Year( props ) {

    let asOfDate = 'December 31';

    if(props.isMostRecent) {
        asOfDate = props.mostRecentAsOf;
    }

    useEffect(() => {
    }, []);

    const handleCurrentItem = (e) => {
        props.updateCurentItem(e);
    }

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1, // Number of decimal places
    });

    const handleClick = (e) => {
        // e.preventDefault();
        // if(e.target.attributes.id.value !== undefined) {
        //     const target = document.getElementById(e.target.attributes.id.value);
        //     target
        // }
    };

    return (
        <div className={`timeline-year${props.isCurrent ? ' current' : ''}`}>
            <h3>{props.name}</h3>
            {props.aum > 0 &&
                <p className="timeline-year-aum">{formatter.format(props.aum)} AUM<a href={`#aum-note-${props.name}`} onClick={handleClick}><span id={`aum-note-link-${props.name}`} title="See citation">*</span></a></p>
            }
            {props.locations && props.locations.map((item) => (
                <Item
                    id={item.id}
                    slug={item.slug}
                    name={item.name}
                    key={item.id}
                    locations={item.locations}
                    type={item.type}
                    asOfDate={item.as_of_date}
                    description={item.description}
                    aum={item.aum}
                    logo={item.logo}
                    currentItem={props.currentItem}
                    updateCurrentItem={handleCurrentItem}
                ></Item>
            ))}
            {props.aum > 0 &&
                <p className="aum-as-of" id={`aum-note-${props.name}`}><a href={`#aum-note-link-${props.name}`} onClick={handleClick} title="Jump up">*</a> As of {asOfDate}, {props.name}</p>
            }
        </div>
    );
}

export default Year;
